import { Tabs } from '../components/Tabs/Tabs'
import { Item } from '@react-stately/collections'
import { BarChart } from 'blaze-ui/icons'
import Styles from '../Analytics.module.scss'
import { Overview } from './Overview'
import { useAnalyticsTabs } from '../hooks/useAnalyticsTabs'

const FacebookAnalytics = () => {
  const { tab, handleTabChange } = useAnalyticsTabs()

  return (
    <div className={Styles.content}>
      <Tabs aria-label="Facebook Analytics Tabs" selectedKey={tab} onSelectionChange={handleTabChange}>
        <Item
          key="overview"
          title={
            <div className={Styles.tabTitle}>
              <BarChart />
              Overview
            </div>
          }
        >
          <Overview />
        </Item>
      </Tabs>
    </div>
  )
}

export default FacebookAnalytics
